import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout, tap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoadingSpinnerService } from '../shared/components/loading-spinner/loading-spinner.service';
import { ErrorBannerService } from '../shared/components/error-banner/error-banner.service';

export const SKIP_SPINNER_DELAY = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  private readonly TIMEOUT_DURATION = 90000; // 90s
  private readonly SPINNER_DELAY = 1500;      // 1500ms

  private ongoingRequests = 0;
  private spinnerTimeout: any;

  constructor(
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private errorBannerService: ErrorBannerService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();

    const skipDelay = request.context.get(SKIP_SPINNER_DELAY);

    let customHeaders = request.headers.set('Content-Type', 'application/json');
    const clonedRequest = request.clone({ headers: customHeaders });

    this.ongoingRequests++;
    if (this.ongoingRequests === 1) {
      if (!skipDelay) {
        this.spinnerTimeout = setTimeout(() => this.spinnerService.show(), this.SPINNER_DELAY);
      } else {
        this.spinnerService.show();
      }
    } else {
      this.spinnerService.show();
    }

    return next.handle(clonedRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - startTime;
          console.log('');
          console.log(`URL: ${request.url}`);
          console.log(`Status: ${event.status}, Response Time: ${duration}ms`);
          console.log('');
        }
      }),
      timeout(this.TIMEOUT_DURATION),
      catchError((error: any) => {
        if (error.name === 'TimeoutError') {
          console.log('timeout error', error.message);
          this.errorBannerService.show();
        } else if (error instanceof HttpErrorResponse) {
          if (error.status >= 400) {
            this.errorBannerService.show();
          }
        }
        return throwError(() => error);
      }),
      finalize(() => {
        clearTimeout(this.spinnerTimeout);
        this.ongoingRequests--;
        if (this.ongoingRequests === 0) {
          this.spinnerService.hide();
        }
      })
    );
  }
}
